<template>
  <div class="formc">
    <div class="formc-con">
      <p class="tip-r">提示：以下填报项单位为万元，请确认填报数据符合单位规范。</p>
      <el-form :model="data" :rules="rules" ref="elFormRef" inline-message scroll-to-error :scroll-into-view-options="{ behavior: 'smooth', block: 'center' }">
        <table class="el-table-s3">
          <tbody>
            <tr>
              <td class="table-label" width="212" height="40">
                <span>资产总额</span>
              </td>
              <td width="460">
                <div class="td-c1">
                  <el-form-item prop="assgro">
                    <el-input v-model.trim="data.assgro" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="assgrodis">
                    <el-radio-group v-model="data.assgrodis">
                      <el-radio value="1">公示</el-radio>
                      <el-radio value="2">不公示</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </td>
            </tr>

            <tr>
              <td class="table-label" width="212" height="40">
                <span>所有者权益合计</span>
              </td>
              <td width="460">
                <div class="td-c1">
                  <el-form-item prop="totequ">
                    <el-input v-model.trim="data.totequ" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="totequdis">
                    <el-radio-group v-model="data.totequdis">
                      <el-radio value="1">公示</el-radio>
                      <el-radio value="2">不公示</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </td>
            </tr>

            <tr>
              <td class="table-label" width="212" height="40">
                <span>负债总额</span>
              </td>
              <td width="460">
                <div class="td-c1">
                  <el-form-item prop="liagro">
                    <el-input v-model.trim="data.liagro" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="liagrodis">
                    <el-radio-group v-model="data.liagrodis">
                      <el-radio value="1">公示</el-radio>
                      <el-radio value="2">不公示</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </td>
            </tr>

            <tr>
              <td class="table-label" width="212" height="40">
                <span>营业总收入</span>
              </td>
              <td width="460">
                <div class="td-c1">
                  <el-form-item prop="vendinc">
                    <el-input v-model.trim="data.vendinc" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="vendincdis">
                    <el-radio-group v-model="data.vendincdis">
                      <el-radio value="1">公示</el-radio>
                      <el-radio value="2">不公示</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </td>
            </tr>

            <tr>
              <td class="table-label" width="212" height="40">
                <span>其中主营业收入</span>
              </td>
              <td width="460">
                <div class="td-c1">
                  <el-form-item prop="maibusinc">
                    <el-input v-model.trim="data.maibusinc" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="maibusincdis">
                    <el-radio-group v-model="data.maibusincdis">
                      <el-radio value="1">公示</el-radio>
                      <el-radio value="2">不公示</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </td>
            </tr>

            <tr>
              <td class="table-label" width="212" height="40">
                <span>利润总额</span>
              </td>
              <td width="460">
                <div class="td-c1">
                  <el-form-item prop="progro">
                    <el-input v-model.trim="data.progro" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="progrodis">
                    <el-radio-group v-model="data.progrodis">
                      <el-radio value="1">公示</el-radio>
                      <el-radio value="2">不公示</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </td>
            </tr>

            <tr>
              <td class="table-label" width="212" height="40">
                <span>净利润</span>
              </td>
              <td width="460">
                <div class="td-c1">
                  <el-form-item prop="netinc">
                    <el-input v-model.trim="data.netinc" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="netincdis">
                    <el-radio-group v-model="data.netincdis">
                      <el-radio value="1">公示</el-radio>
                      <el-radio value="2">不公示</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </td>
            </tr>

            <tr>
              <td class="table-label" width="212" height="40">
                <span>纳税总额</span>
              </td>
              <td width="460">
                <div class="td-c1">
                  <el-form-item prop="ratgro">
                    <el-input v-model.trim="data.ratgro" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="ratgrodis">
                    <el-radio-group v-model="data.ratgrodis">
                      <el-radio value="1">公示</el-radio>
                      <el-radio value="2">不公示</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </el-form>
    </div>

    <div class="formc-btn">
      <el-button type="primary" color="#d1ab62" size="large" @click="save">保存</el-button>
      <el-button type="primary" color="#d1ab62" size="large" @click="emits('emit', 'gotoPage', 'center')">返回</el-button>
    </div>

    <authorizeDialog ref="authorizeDialogRef" @submit="authorizeDialogSubmit" />
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import authorizeDialog from "../authorizeDialog.vue";

const initialAnswer = inject("initialAnswer");

const props = defineProps({
  data: {
    type: Object,
    defaults() {
      return {};
    },
  },
});

const elFormRef = ref();

const data = ref({});

const rulesConfig = { required: true, trigger: ["blur", "change"], message: "不能为空" };

const rules = ref({
  assgro: [rulesConfig],
  assgrodis: [rulesConfig],
  totequ: [rulesConfig],
  totequdis: [rulesConfig],
  liagro: [rulesConfig],
  liagrodis: [rulesConfig],
  vendinc: [rulesConfig],
  vendincdis: [rulesConfig],
  maibusinc: [rulesConfig],
  maibusincdis: [rulesConfig],
  progro: [rulesConfig],
  progrodis: [rulesConfig],
  netinc: [rulesConfig],
  netincdis: [rulesConfig],
  ratgro: [rulesConfig],
  ratgrodis: [rulesConfig],
});

const save = () => {
  elFormRef.value.validate((isValid) => {
    if (isValid) {
      emits("emit", "submit", data.value);
    }
  });
};

const authorizeDialogRef = ref(null);

const authorizeDialogSubmit = () => {
  // 使用初始数据
  data.value = Object.assign({}, data.value, cloneDeep(initialAnswer.value[0] || {}));
  authorizeDialogRef.value.close();
};

const emits = defineEmits(["emit"]);

onMounted(() => {
  data.value = cloneDeep(props.data);

  // 有已保存数据使用已保存数据
  if (data.value.assgro != undefined) {
    return;
  }

  // 否则 先提示授权 再使用初始数据
  authorizeDialogRef.value.open();
});
</script>

<style lang="scss" scoped>
.formc {
  .tip-r {
    padding: 7px;
    color: red;
  }
}
</style>
